import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamQuarterlyBonusResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
  quarter?: number;
};

const getTeamQuarterlyBonus = async (params: Params): Promise<TeamQuarterlyBonusResponse> => {
  const { data } = await api.get(`${BI_BASE_URL}/managers/team/quarterly/bonus`, { params });

  return data;
};

export const useGetTeamQuarterlyBonus = ({ year, quarter }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_QUARTERLY_BONUS, year, quarter],
    queryFn: () => {
      return getTeamQuarterlyBonus({ year, quarter });
    },
  });
};
